"use client";

import Cookies from "js-cookie";
// import { cookies } from "next/headers";
import { createContext, useContext, useEffect, useState } from "react";

const DemoContext = createContext();

export const DemoProvider = ({ children }) => {
  const [demoValue, setDemoValueState] = useState(false);

  useEffect(() => {
    const cookieValue = Cookies.get("demoValue");
    
    if (cookieValue !== undefined) {
      setDemoValueState(cookieValue);
    }
  }, []);

  // Update value in state and cookie
  const setDemoValue = (value) => {
    setDemoValueState(value);
    Cookies.set("demoValue", value, { expires: 7 }); // persist for 7 days
  };


  return (
    <DemoContext.Provider value={{ demoValue, setDemoValue }}>
      {children}
    </DemoContext.Provider>
  );
};

export const useDemo = () => useContext(DemoContext);
